import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import HelpMessage from "./HelpMessage";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import moment from "moment";
import axios from "axios"; // Import Axios

const EditSubnote = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams();

  const { note } = location.state || {}; // Retrieve note data from location state

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [notes, setNotes] = useState(""); // State to hold the notes
  
  const [loading, setLoading] = useState(true);

  const [fieldData, setFieldData] = useState({
    noteId: id,
    createdAt: ''
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_BASEURL + "/api/subnote/" + id,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
          }
        );
        const subNoteData = response.data;
        setNotes(subNoteData.notes || "");
        setFieldData({
          ...fieldData,
          notes: subNoteData.notes || "",
          createdAt: subNoteData.fdate ? moment(subNoteData.fdate).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY"),
        });
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Function to handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Check if notes are not empty before sending the API request
    if (fieldData.notes.trim() === "" ) {
      alert("Notes cannot be empty.");
      return;
    }

    // Prepare the data to be sent to the server
    const dataToSave = {
      note: fieldData.notes,
      subNoteId: id,
      indexkey: note.indexkey
    };

    // Make the API request to save the data
    try {
      const response = await axios.put(
        process.env.REACT_APP_API_BASEURL + "/api/subnote",
        dataToSave,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        }
      );
      // Redirect to AdminNotes page after saving
      navigate("/AdminNotes");
      // Scroll to top
      window.scrollTo(0, 0);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  if (loading) {
    return (
      <div className="customer-layout">
        <Navbar />
        <main className="customer-main">
          <div className="card">
            <p>Loading...</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="customer-layout">
      <Navbar />
      <main className="customer-main">
        <section className="card">
          <header className="card-header">
            <h1 className="card-title">Edit Subnote</h1>
            <p className="card-subtitle">Edit the follow-up note for this incident</p>
          </header>

          <form onSubmit={handleFormSubmit} className="form-stack">
            <input defaultValue="0" name="Id" type="hidden" />
            <input name="Indexkey" type="hidden" value={note?.indexkey || ""} />

            <div className="form-grid">
              <div className="form-field">
                <label htmlFor="createdDate">
                  Created Date <span style={{ color: "red" }}>*</span>
                </label>
                <div className="form-field-control">
                  <input
                    id="createdDate"
                    type="text"
                    value={fieldData.createdAt || ""}
                    disabled
                    style={{
                      backgroundColor: "#f5f5f5",
                      cursor: "not-allowed"
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="form-field">
              <label htmlFor="notes">
                Notes <span style={{ color: "red" }}>*</span>
              </label>
              <div className="form-field-control">
                <textarea
                  id="notes"
                  name="Notes"
                  value={fieldData.notes || ""}
                  onChange={(e) => {
                    setFieldData({
                      ...fieldData,
                      notes: e.target.value
                    });
                  }}
                  maxLength={99}
                  rows={5}
                  style={{
                    width: "100%",
                    borderRadius: "14px",
                    border: "1px solid rgba(20, 34, 58, 0.12)",
                    padding: "12px 16px",
                    fontSize: "15px",
                    fontFamily: "inherit",
                    resize: "vertical",
                    minHeight: "120px"
                  }}
                  placeholder="Enter your note here..."
                />
              </div>
            </div>

            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "24px" }}>
              <button
                type="button"
                className="button ghost"
                onClick={() => {
                  navigate("/Notes/EditNotes", { state: { note: note } });
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="button"
              >
                Update
              </button>
            </div>
          </form>
        </section>

        <div className="home-help">
          <HelpMessage />
        </div>
      </main>
    </div>
  );
};

export default EditSubnote;
